export const clientConstants = {
  users: ['User Name', 'Login ID', 'Email', 'Active', 'Admin'],
  contacts: ['Contact Name', 'Email', 'Phone', 'Primary User'],
  dashboardUsers: ['User Name', 'Login ID', 'Email'],
  permissions: [
    {
      PermissionId: '22',
      PermissionName: 'Personal Notes'
    },
    {
      PermissionId: '23',
      PermissionName: 'Edit Notes Dropdown'
    },
    {
      PermissionId: '24',
      PermissionName: 'Group Notes Email Alerts'
    },
    {
      PermissionId: '27',
      PermissionName: 'Legis: View'
    },
    {
      PermissionId: '28',
      PermissionName: 'Legis: View Group Notes'
    },
    {
      PermissionId: '29',
      PermissionName: 'Legis: Edit Group Notes'
    },
    {
      PermissionId: '30',
      PermissionName: 'Legis: Edit Subjects'
    },
    {
      PermissionId: '31',
      PermissionName: 'Legis: Delete Records'
    },
    {
      PermissionId: '32',
      PermissionName: 'Legis: Admin Subjects (Change, Add, Archive)'
    },
    {
      PermissionId: '38',
      PermissionName: 'Regs: View'
    },
    {
      PermissionId: '39',
      PermissionName: 'Regs: View Group Notes'
    },
    {
      PermissionId: '40',
      PermissionName: 'Regs: Edit Group Notes'
    },
    {
      PermissionId: '41',
      PermissionName: 'Regs: Edit Subjects'
    },
    {
      PermissionId: '42',
      PermissionName: 'Regs: Delete Records'
    },
    {
      PermissionId: '43',
      PermissionName: 'Regs: Add Regs'
    },
    {
      PermissionId: '48',
      PermissionName: 'Local: View'
    },
    {
      PermissionId: '49',
      PermissionName: 'Local: View Group Notes'
    },
    {
      PermissionId: '50',
      PermissionName: 'Local: Edit Group Notes'
    },
    {
      PermissionId: '51',
      PermissionName: 'Local: Edit Subjects'
    },
    {
      PermissionId: '52',
      PermissionName: 'Local: Delete Records'
    },
    {
      PermissionId: '56',
      PermissionName: 'Bill Finder: View Text Search'
    },
    {
      PermissionId: '57',
      PermissionName: 'Bill Finder: Add From Text Search'
    },
    {
      PermissionId: '59',
      PermissionName: 'Quick Links: View'
    },
    {
      PermissionId: '60',
      PermissionName: 'Quick Links: Admin Client Sharing'
    },
    {
      PermissionId: '61',
      PermissionName: 'Quick Links: Admin Group Notes Sharing'
    },
    {
      PermissionId: '62',
      PermissionName: 'Quick Links: Admin Public Links'
    },
    {
      PermissionId: '63',
      PermissionName: 'Quick Links: Show Only Quick Links'
    },
  ],
  inputsUser: [
    {
      title: 'Last Logon:',
      fieldName: 'LastLogin',
    },
    {
      title: 'Last Update:',
      fieldName: 'LastUpdate',
    },
    {
      title: 'Multi Client:',
      fieldName: 'MultiClient',
    },
    {
      title: 'Last Updated User:',
      fieldName: 'LastUpdateBy',
    }
  ],
  dashboardInputsUser: [
    {
      title: 'Last Login Date:',
      fieldName: 'LastLogin',
    },
    {
      title: 'Subscribed to Email Alerts:',
      fieldName: 'subscribedAlerts',
    }
  ],
  inputsContact: [
    {
      fieldName: 'Title',
      title: 'Title',
      type: 'input'
    },
    {
      fieldName: 'PhoneNumber2',
      title: 'Phone 2',
      type: 'input'
    },
  ],
  checkboxesContacts: [
    {
      fieldName:'IsSignatory',
      title:'Signatory',
      type: 'checkbox'
    },
    {
      fieldName:'IsBilling',
      title:'Billing',
      type: 'checkbox'
    },
    {
      fieldName:'IsTechnical',
      title:'Tech',
      type: 'checkbox'
    },
  ],
  inputsList: {
    clientContacts: [
      {
        type: 'input',
        name: 'ContactName',
        title: 'Contact Name',
      },
      {
        type: 'input',
        name: 'Email',
        title: 'Email',
      },
      {
        type: 'input',
        name: 'PhoneNumber',
        title: 'Phone',
      },
      {
        type: 'checkbox',
        name: 'IsPrimary',
        title: 'Primary User',
      },
    ],
    clientUsers: [
      {
        type: 'input',
        name: 'UserName',
        title: 'User Name',
      },
      {
        type: 'input',
        name: 'LogonId',
        title: 'Login ID',
      },
      {
        type: 'input',
        name: 'UserEmail',
        title: 'Email',
      },
      {
        type: 'checkbox',
        name: 'IsActive',
        title: 'Active',
      },
      {
        type: 'checkbox',
        name: 'IsAdmin',
        title: 'Admin',
      },
    ],
    dashboardUsers: [
      {
        type: 'input',
        name: 'UserName',
        title: 'User Name',
      },
      {
        type: 'input',
        name: 'LogonId',
        title: 'Login ID',
      },
      {
        type: 'input',
        name: 'UserEmail',
        title: 'Email',
      },
    ]
  },
  emptyList: {
    clientUser: [{
      ClientId: 0,
      FirstName: '',
      IsActive: false,
      IsAdmin: false,
      LastLogin: '',
      LastName: '',
      LastUpdate: '',
      LastUpdateBy: '',
      LogonId: '',
      MultiClient: null,
      Password: null,
      Permissions: [],
      ResetPassword: false,
      UserEmail: '',
      UserId: 0,
    }],
    clientContact: [{
      City:'',
      ClientContactId:0,
      ClientId:0,
      ContactName:'',
      Email:'',
      FaxNumber:null,
      HolidayCard:false,
      IsBilling:false,
      IsPrimary:false,
      IsSignatory:false,
      IsTechnical:false,
      PhoneNumber:'',
      PhoneNumber2:'',
      SortOrder:null,
      State:null,
      StreetAddress1:'',
      StreetAddress2:'',
      Title:'',
      UserId:null,
      ZipCode:null,
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/ClientContacts/constants.js